import { useMemo } from 'react';

import { useIntl } from 'react-intl';

const REACT_APP_CMS_URL = process.env.REACT_APP_CMS_URL;

interface Options {
  disableRef?: boolean;
  newSignup?: boolean;
}

const handleRefPart = (opts: Options) => {
  if (opts.disableRef) {
    return '';
  }

  return `?ref=${encodeURIComponent(document.location.href)}`;
};

const handleNewSignupPart = (opts: Options) => {
  if (opts.newSignup) {
    return `${handleRefPart(opts) ? '&' : '?'}new_signup=true`;
  }

  return '';
};

export const pricingPageURL = (locale: string, opts: Options = {}) => {
  const refPart = handleRefPart(opts);

  const newSignupPart = handleNewSignupPart(opts);

  return `${REACT_APP_CMS_URL}/${locale.toLowerCase()}/subscription${refPart}${newSignupPart}`;
};

export const useUrls = () => {
  const { locale } = useIntl();

  const pricingPage = useMemo(() => pricingPageURL(locale), [locale]);

  return { pricingPage };
};
